import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  AdminOrganization,
  AdminOrganizationOrderByKey,
} from 'src/app/admin/models/organization.model';
import { AdminOrganizationApiError } from './admin-organization.errors';
import { SortOrder } from 'studio-components';
import { UndeployAllProjectsTask } from 'src/app/admin/models/task.model';

export const AdminLoadOrganizations = createAction('[Admin Organization] Load Organizations');

export const AdminLoadOrganizationsCsv = createAction(
  '[Admin Organization] Load Organizations Csv',
);

export const AdminOrganizationsLoaded = createAction(
  '[Admin Organization] Organizations Loaded',
  props<{ organizations: AdminOrganization[]; total: number }>(),
);

export const AdminIncludedDeletedOrganizationsChanged = createAction(
  '[Admin Organization] Include Deleted Organizations Changed',
  props<{ includeDeleted: boolean }>(),
);

export const AdminOrganizationPageChanged = createAction(
  '[Admin Organization] Page Changed',
  props<{ page: number }>(),
);

export const AdminOrganizationSortChanged = createAction(
  '[Admin Organization] Sort Changed',
  props<{ sortOrder: SortOrder; orderBy: AdminOrganizationOrderByKey }>(),
);

export const AdminOrganizationsSearchChanged = createAction(
  '[Admin Organization] Search Changed',
  props<{ search: string }>(),
);

export const AdminSetOrganizationsCsv = createAction('[Admin Organization] Set Organization Csv');

export const AdminLoadCurrentOrganization = createAction(
  '[Admin Organization] Load Current Organization',
  props<{ id: number }>(),
);

export const AdminSetCurrentOrganization = createAction(
  '[Admin Organization] Set Current Organization',
  props<{ organization: AdminOrganization }>(),
);

export const AdminResetCurrentOrganization = createAction(
  '[Admin Organization] Reset Current Organization',
);

export const AdminCreateOrganization = createAction(
  '[Admin Organization] Create Organization',
  props<{
    name: string;
    displayName: string;
    description: string;
    organizationType: string;
    addDefaultConfig: boolean;
    addStockDPS: boolean;
  }>(),
);

export const AdminUpdateOrganization = createAction(
  '[Admin Organization] Update Organization',
  props<{
    id: number;
    organization: Partial<AdminOrganization>;
  }>(),
);

export const AdminOpenOrganization = createAction(
  '[Admin Organization] Open Organization',
  props<{ id: number }>(),
);

export const AdminDeleteOrganization = createAction(
  '[Admin Organization] Delete Organization',
  props<{ id: number }>(),
);

export const AdminHardDeleteOrganization = createAction(
  '[Admin Organization] Hard Delete Organization',
  props<{ id: number }>(),
);

export const AdminOpenOrganizations = createAction('[Admin Organization] Open Organizations');

export const AdminSetOrganizationError = createAction(
  '[Admin Organization] Set Organization Error',
  props<{ error: AdminOrganizationApiError }>(),
);

export const AdminSetOrganizationsCsvError = createAction(
  '[Admin Organization] Set Organizations Csv Error',
  props<{ error: AdminOrganizationApiError }>(),
);

export const AdminRemoveOrganizationError = createAction(
  '[Admin Organization] Remove Organization Error',
);

export const AdminOrganizationsExited = createAction('[Admin Organization] Organizations Exited');

export const AdminOrganizationListActions = createActionGroup({
  source: 'Admin Organization List',
  events: {
    'Undeploy All Projects Confirmed': props<{ organizationId: number }>(),
  },
});

export const AdminOrganizationEffectActions = createActionGroup({
  source: 'Admin Organization',
  events: {
    'Undeploy All Projects in Organization Started': props<{ task: UndeployAllProjectsTask }>(),
    'Undeploy All Projects in Organization Succeeded': emptyProps(),
    'Undeploy All Projects in Organization Errored': props<{
      error: AdminOrganizationApiError;
    }>(),
  },
});
